import {Grid, Typography} from "@mui/material";

interface GameInfoToolTipRowProps {
    label: string
    teamValue: string | number
    oppValue: string | number
}

export const GameInfoToolTipRow = ({label, teamValue, oppValue}: GameInfoToolTipRowProps) => {

    const isTeamLabel = label === 'Team';
    return (
        <Grid xs={12} container item display="flex" justifyContent="space-around">
            <Grid item container xs={4} justifyContent="center">
                <Typography variant={isTeamLabel ? 'body1' : "body2"} align="center" fontWeight={isTeamLabel ? '600' : ''}>
                    {typeof teamValue === 'number' ? `${(teamValue * 100).toFixed(1)}%` : teamValue}
                </Typography>
            </Grid>
            <Grid item container xs={4} justifyContent="center">
                <Typography variant={isTeamLabel ? 'body1' : "body2"} align="center" fontWeight={'600'}>
                    {label}
                </Typography>
            </Grid>
            <Grid item container xs={4} justifyContent="center">
                <Typography variant={isTeamLabel ? 'body1' : "body2"} align="center" fontWeight={label === 'Team' ? '600' : ''}>
                    {typeof oppValue === 'number' ? `${(oppValue * 100).toFixed(1)}%` : oppValue}
                </Typography>
            </Grid>
        </Grid>
    )
}